import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type ServiceIntervalClasses = 'itemContainer' | 'itemLabel' | 'itemValue';

const serviceIntervalStyles = makeStyles<ISpcTheme, ServiceIntervalClasses>(
  theme => ({
    itemContainer: {
      padding: `${theme.spacing(0.75)} 0`,
    },
    itemLabel: {
      color: theme.palette.text.disabled,
    },
    itemValue: {
      color: theme.palette.text.disabled,
      fontSize: theme.typography.fontSM,
    },
  }),
  { name: 'Customise_ServiceInterval' },
);

export default serviceIntervalStyles;
